// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"c7f6bdcb","676":"be5e090d","790":"7718cbd1"}[chunkId] + ".chunk.css";
};